import {
  browserSessionPersistence,
  indexedDBLocalPersistence,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  User,
} from 'firebase/auth';

import { FirebaseService } from './';

export class AuthService {
  public auth = FirebaseService.Auth;

  initAuthListener = (
    onLogin: (credential: User) => void,
    onLogout: () => void,
  ) => {
    return this.auth.onAuthStateChanged(credential => {
      // If credential is not set, trigger onLogout callback
      if (!credential) {
        onLogout();
        return;
      }

      onLogin(credential);
    });
  };

  /** Signing out has to take the persisted Firestore cache with it, or the
   * documents this session read stay on the device for the next person to use
   * it. Purging reloads the app, so it must come last. */
  logoutAsync = async () => {
    await this.auth.signOut();
    await FirebaseService.purgePersistedCache();
  };

  loginWithEmailAndPasswordAsync = async (
    email: string,
    password: string,
    rememberMe: boolean,
  ) => {
    await this.auth.setPersistence(
      rememberMe ? indexedDBLocalPersistence : browserSessionPersistence,
    );

    return signInWithEmailAndPassword(this.auth, email, password);
  };

  sendPasswordResetEmail = (email: string) =>
    sendPasswordResetEmail(this.auth, email);
}
